import { BACKEND_URL } from '../config/constants'

export const processPayment = ({id, action, env}) => {
    console.log("URL: ", BACKEND_URL + action)
    return fetch(BACKEND_URL + action, {
        method: 'POST',
        //mode: 'no-cors',
        // headers: {
        //     "Content-Type": "application/json"
        // },
        body: JSON.stringify({
            id,
            env
        }),
    })
}